



























































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { IOrderDto } from "@/types/interface/IOrderDto";
import { OrderDto } from "@/types/impl/OrderDto";
import { IUserInfoDto } from "@/types/interface/IUserInfoDto";
import { IOrderItemDto } from "../../../types/interface/IOrderItem";
import BigNumber from "bignumber.js";
import {
  OrderItemType,
  OrderStatus,
  OrderItemSubType
} from "../../../types/enum/OrderEnum";
import PaymentTypeComponent from "@/components/paymen-type.vue";
import DeliveryTypeComponent from "@/components/delivery-type.vue";
import OrderStepStateComponent from "./order-step-status.vue";
import PaymentStatusComponent from "@/components/payment-status.vue";
import HeaderComponent from "./order-row-header.vue";
import { IOrderCancellationRequestDto } from "../../../types/interface/IOrderCancellationRequestDto";
import { orderCancellationRequestDto } from "../../../types/impl/IOrderCancellationRequestDto";
import USD from "@/components/USD.vue";
import { State, Getter, Action, Mutation } from "vuex-class";
import { getRefundableAmount } from "@/api/net/order.ts";
import store from "../../../store/index";
@Component({
  name: "refund-order-row",
  components: {
    PaymentTypeComponent,
    DeliveryTypeComponent,
    OrderStepStateComponent,
    PaymentStatusComponent,
    HeaderComponent,
    USD
  }
})
export default class OrderRow extends Vue {
  @Prop({ default: () => ({ ...orderCancellationRequestDto }) })
  refundOrder!: IOrderCancellationRequestDto;
  @Prop({ default: -1 }) index!: number;

  @Action("handleRefundOrderList")
  private actionHandleRefundOrderList!: (merchId: string) => Promise<any>;

  orderItemIds: Array<string> = [];
  timeout: any;
  refundMoney: number = this.refundOrder.userRequestRefundAmount;
  calculatingRefundAmount: boolean = false;
  orderGroup: Array<string> = store.state.refundOrderList;

  orderItemPriceCalculation(
    subTotalExcludeTax: number,
    taxAmount: number
  ): string {
    return new BigNumber(subTotalExcludeTax).plus(taxAmount).toFixed(2);
  }

  public get userRequestRefundPercentage(): string {
    return this.refundOrder.userRequestRefundPercentage
      ? `(${this.refundOrder.userRequestRefundPercentage}%)`
      : "";
  }

  public get order(): IOrderDto {
    return this.refundOrder.order;
  }

  public get deliveryType(): string {
    return this.order.deliveryType === 1 ? "Delivery" : "Pickup";
  }

  public get orderItems(): IOrderItemDto[] {
    return this.refundOrder.orderCancellationItems || [];
  }

  public get address(): string {
    return `${this.order.address.houseNumber} ${this.order.address.address1}`;
  }

  changeRefundPercentage(val: number) {
    this.debounce(this.getRefundAmount, val, 700);
  }

  public toOrderDetailPage(): void {
    this.$router.push({
      name: "Order Detail",
      query: {
        orderId: this.order.id
      }
    });
  }

  async getRefundAmount(inputValue: number) {
    this.calculatingRefundAmount = true;
    let {
      status,
      data: { refundableAmountTotal }
    } = await getRefundableAmount(
      this.order.merchId,
      this.order.id,
      Number(inputValue)
    );
    if (status === 200) {
      this.refundOrder.userRequestRefundPercentage = inputValue;
      this.refundMoney = refundableAmountTotal;
    }
    store.commit("handleShowLoading", false);
    this.calculatingRefundAmount = false;
  }

  updateRefundOrderList(orderId: string, merchId: string) {
    this.$emit("updateOrderList", orderId, merchId);
    this.$emit("updateRefundOrderList");
  }

  debounce(callback: Function, val: number, wait: number) {
    return (() => {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        callback(val);
      }, wait);
    })();
  }
}
